const ICON_BASE = "/assets/images/lifestyle/how-it-works";

/** Points right by default; the modal rotates it to point down between steps. */
export const ARROW_ICON = `${ICON_BASE}/arrow-right.svg`;

/** Shared by the hero explainer and the mobile "how it works" modal. */
export const STEPS = [
  {
    title: "Choose your prize",
    description: "Pick your prize: Browse 200+ prizes and pick the one you really want",
    icon: `${ICON_BASE}/click-icon.svg`,
  },
  {
    title: "Buy your tickets",
    description: "Buy your tickets: Each ticket is linked to your prize. Buy as many as you like.",
    icon: `${ICON_BASE}/ticket-icon.svg`,
  },
  {
    title: "Win what you picked",
    description: "Win your prize: One ticket is drawn every Tuesday. If it’s yours, you win your prize.",
    icon: `${ICON_BASE}/trophy-icon.svg`,
  },
];
